module.exports = __webpack_public_path__ + "img/bio1.9b740321.png";